import { useRouter } from "next/router";

interface Props {
	children: any;
	list: boolean;
	country: any;
	initial: boolean;
	type?: string;
	data?: any;
}

export function GeoHandler({
	list,
	country,
	initial,
}: Pick<Props, "list" | "country" | "initial">) {
	const router = useRouter();
	const currentCountry = router.query.country as string | undefined;
	const ignoreGeo = router.query.ignoregeo as string | undefined;

	// Wait for router query to be ready if not ignoring geo or initial
	if (!initial && ignoreGeo !== "true" && !router.isReady) {
		return false; // Return false while router is not ready
	}

	if (initial !== false || ignoreGeo == "true") return true;

	if (list) {
		var availableCountries = country?.some(
			(c: any) => c.countryCode !== currentCountry
		);
	} else {
		var availableCountries = country?.some(
			(c: any) => c.countryCode == currentCountry
		);
	}
	if (availableCountries) return true;

	return false;
}

export default function GeoWrapper({
	children,
	list,
	country,
	initial,
}: Props) {
	const router = useRouter();
	const currentCountry = router.query.country as string | undefined;
	const ignoreGeo = router.query.ignoregeo as string | undefined;

	// Wait for router query to be ready
	if (!router.isReady && !initial && ignoreGeo !== "true") {
		return null; // Don't render anything until router is ready
	}

	if (initial !== false || ignoreGeo == "true") {
		return children;
	} else {
		if (list) {
			var availableCountries = country?.some(
				(c: any) => c.countryCode !== currentCountry
			);
		} else {
			var availableCountries = country?.some(
				(c: any) => c.countryCode == currentCountry
			);
		}

		if (availableCountries) {
			return children;
		} else {
			return null;
		}
	}
}

export function GeoWrapperPage({ list, country, initial, children }: Props) {
	const router = useRouter();
	const currentCountry = router.query.country as string | undefined;
	const ignoreGeo = router.query.ignoregeo as string | undefined;

	// Wait for router query to be ready
	if (!router.isReady && !initial && ignoreGeo !== "true") {
		return null; // Don't render anything until router is ready
	}

	if (initial !== false || ignoreGeo == "true") {
		return children;
	} else {
		if (list) {
			var availableCountries = country?.some(
				(c: any) => c.countryCode !== currentCountry
			);
		} else {
			var availableCountries = country?.some(
				(c: any) => c.countryCode == currentCountry
			);
		}

		if (availableCountries) {
			return children;
		} else {
			return <></>; // Keep empty fragment as per original logic for this specific wrapper
		}
	}
}
